module.exports = __webpack_public_path__ + "static/media/basket.0f35e215.svg";